var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import IconLeft from '../../icon/react-icon/IconLeft';
import IconRight from '../../icon/react-icon/IconRight';
import IconUp from '../../icon/react-icon/IconUp';
import IconDown from '../../icon/react-icon/IconDown';
import cs from '../_util/classNames';
import { ConfigConsumer } from '../ConfigProvider';
var CarouselArrow = /** @class */ (function (_super) {
    __extends(CarouselArrow, _super);
    function CarouselArrow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderArrow = function (_a) {
            var _b;
            var getPrefixCls = _a.getPrefixCls;
            var _c = _this.props, _d = _c.direction, direction = _d === void 0 ? 'horizontal' : _d, _e = _c.showArrow, showArrow = _e === void 0 ? 'always' : _e;
            var prefixCls = getPrefixCls('carousel');
            var arrowClass = cs(prefixCls + "-arrow", (_b = {},
                _b[prefixCls + "-arrow-vertical"] = direction === 'vertical',
                _b[prefixCls + "-arrow-hover"] = showArrow === 'hover',
                _b), _this.props.className);
            return (React.createElement("div", { className: arrowClass },
                React.createElement("div", { className: prefixCls + "-arrow-left", onClick: _this.props.prev }, direction === 'horizontal' ? React.createElement(IconLeft, null) : React.createElement(IconUp, null)),
                React.createElement("div", { className: prefixCls + "-arrow-right", onClick: _this.props.next }, direction === 'horizontal' ? React.createElement(IconRight, null) : React.createElement(IconDown, null))));
        };
        return _this;
    }
    CarouselArrow.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderArrow);
    };
    return CarouselArrow;
}(Component));
export default CarouselArrow;
